// extracted by mini-css-extract-plugin
module.exports = {"footerLogo":"footer-module--footer-logo--1OA98"};